/* Fun Life 2027 — motion, sound, menu, search, booking, Bhuka demo */
(function () {
  'use strict';
  var doc = document;
  var root = doc.documentElement;
  var $ = function (sel, ctx) { return (ctx || doc).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || doc).querySelectorAll(sel)); };
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var store = {
    get: function (k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { window.localStorage.setItem(k, v); } catch (e) {} }
  };

  /* ------------------------------------------------------------------
     Sound (Web Audio, subtle, only after the first tap)
     ------------------------------------------------------------------ */
  var Sound = {
    on: store.get('fl-sound') !== 'off',
    ctx: null,
    master: null,
    ensure: function (create) {
      if (!this.on) return null;
      if (!this.ctx) {
        if (!create) return null;
        var AC = window.AudioContext || window.webkitAudioContext;
        if (!AC) return null;
        try {
          this.ctx = new AC();
          this.master = this.ctx.createGain();
          this.master.gain.value = 0.6;
          this.master.connect(this.ctx.destination);
        } catch (e) { return null; }
      }
      return this.ctx;
    },
    tone: function (freq, dur, vol, type, glide, create) {
      var ctx = this.ensure(create);
      if (!ctx) return;
      var self = this;
      var play = function () {
        var t0 = ctx.currentTime;
        var o = ctx.createOscillator();
        var g = ctx.createGain();
        o.type = type || 'sine';
        o.frequency.setValueAtTime(freq, t0);
        if (glide) o.frequency.exponentialRampToValueAtTime(glide, t0 + dur * 0.8);
        g.gain.setValueAtTime(0.0001, t0);
        g.gain.exponentialRampToValueAtTime(vol, t0 + 0.01);
        g.gain.exponentialRampToValueAtTime(0.0001, t0 + dur);
        o.connect(g); g.connect(self.master);
        o.start(t0); o.stop(t0 + dur + 0.05);
      };
      if (ctx.state === 'suspended') { ctx.resume().then(play).catch(function () {}); } else { play(); }
    },
    click: function () { this.tone(620, 0.14, 0.05, 'sine', 310, true); },
    key: function () { this.tone(1800, 0.03, 0.008, 'triangle', null, false); },
    tick: function () { this.tone(1500, 0.05, 0.012, 'triangle', null, false); },
    chime: function (i) {
      var notes = [523.25, 587.33, 659.25, 783.99, 880, 1046.5];
      var f = notes[Math.abs(i) % notes.length];
      this.tone(f, 0.6, 0.022, 'sine', null, false);
      this.tone(f * 2, 0.35, 0.006, 'sine', null, false);
    },
    success: function () {
      var self = this;
      this.tone(659.25, 0.3, 0.04, 'sine', null, true);
      setTimeout(function () { self.tone(987.77, 0.5, 0.035, 'sine', null, true); }, 110);
    }
  };
  window.FLSound = Sound;

  function paintSound() {
    root.classList.toggle('fl-muted', !Sound.on);
    $$('[data-fl-sound]').forEach(function (b) { b.setAttribute('aria-pressed', Sound.on ? 'true' : 'false'); });
  }
  paintSound();
  $$('[data-fl-sound]').forEach(function (b) {
    b.addEventListener('click', function () {
      Sound.on = !Sound.on;
      store.set('fl-sound', Sound.on ? 'on' : 'off');
      paintSound();
      if (Sound.on) { Sound.tone(784, 0.25, 0.04, 'sine', null, true); Sound.tone(1046.5, 0.4, 0.03, 'sine', null, true); }
    });
  });
  doc.addEventListener('pointerdown', function (e) {
    var el = e.target && e.target.closest ? e.target.closest('a, button, summary, label') : null;
    if (el && !el.disabled && !el.hasAttribute('data-fl-sound')) { Sound.click(); } else { Sound.ensure(true); }
  }, true);
  doc.addEventListener('input', function (e) {
    var t = e.target;
    if (!t) return;
    if (t.type === 'range') { Sound.tick(); }
    else if (t.matches && t.matches('input[type="text"], input[type="search"], input[type="email"], input[type="tel"]')) { Sound.key(); }
  }, true);

  /* ------------------------------------------------------------------
     Floating, synchronised motion + scroll drift + section chimes
     ------------------------------------------------------------------ */
  var lift = 0, liftTarget = 0, lastY = window.scrollY || 0, secIdx = -1;
  var secs = $$('[data-sec]');
  function checkSection() {
    if (!secs.length) return;
    var vh = window.innerHeight || 800, idx = -1;
    for (var i = 0; i < secs.length; i++) { if (secs[i].getBoundingClientRect().top < vh * 0.55) idx = i; }
    if (idx !== secIdx) {
      var prev = secIdx; secIdx = idx;
      if (prev !== -1 && idx >= 0) Sound.chime(idx);
    }
  }
  if (!reduce) {
    var loop = function () {
      var t = (window.performance ? performance.now() : Date.now()) / 1000;
      lift += (liftTarget - lift) * 0.08;
      liftTarget *= 0.9;
      root.style.setProperty('--fl', (Math.sin(t * Math.PI / 3) * 4 + lift).toFixed(2) + 'px');
      window.requestAnimationFrame(loop);
    };
    window.requestAnimationFrame(loop);
  }
  window.addEventListener('scroll', function () {
    var y = window.scrollY || 0;
    if (!reduce) liftTarget = Math.max(-12, Math.min(12, liftTarget - (y - lastY) * 0.25));
    lastY = y;
    checkSection();
  }, { passive: true });
  setTimeout(checkSection, 300);

  /* ------------------------------------------------------------------
     Menu sheet
     ------------------------------------------------------------------ */
  var sheet = $('#fl-sheet');
  var lastFocus = null;
  function openSheet() {
    if (!sheet) return;
    lastFocus = doc.activeElement;
    sheet.hidden = false;
    doc.body.classList.add('fl-sheet-open');
    $$('[data-fl-menu]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    var first = $('a, button', sheet); if (first) first.focus();
  }
  function closeSheet() {
    if (!sheet || sheet.hidden) return;
    sheet.hidden = true;
    doc.body.classList.remove('fl-sheet-open');
    $$('[data-fl-menu]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  $$('[data-fl-menu]').forEach(function (b) { b.addEventListener('click', openSheet); });
  $$('[data-fl-close]').forEach(function (b) { b.addEventListener('click', closeSheet); });
  if (sheet) {
    sheet.addEventListener('click', function (e) { if (e.target === sheet) closeSheet(); });
    $$('a', sheet).forEach(function (a) { a.addEventListener('click', function () { setTimeout(closeSheet, 10); }); });
    sheet.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeSheet(); });
  }

  /* ------------------------------------------------------------------
     Search (filters service cards, results dropdown, falls back to site search)
     ------------------------------------------------------------------ */
  var search = $('[data-fl-search]');
  $$('[data-fl-search-open]').forEach(function (b) {
    b.addEventListener('click', function (e) {
      var input = $('#fl-q');
      if (!input) { window.location.href = '/search'; return; }
      e.preventDefault();
      closeSheet();
      input.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
      setTimeout(function () { try { input.focus({ preventScroll: true }); } catch (err) { input.focus(); } }, 380);
    });
  });
  if (search) {
    var input = $('#fl-q', search);
    var results = $('[data-fl-results]', search);
    var cards = $$('[data-fl-card]');
    var filter = $('[data-fl-filter]');
    var filterTxt = $('[data-fl-filter-text]');
    var noMatch = $('[data-fl-nomatch]');
    var suggs = $$('[data-fl-sugg]', search);
    var extras = [
      { title: 'Free audit', sub: '15 min · written fix list', keys: 'audit free review check fix help', href: '#book', mark: '15', type: 'audit' },
      { title: '15-min consult', sub: 'Talk through your project', keys: 'consult call meeting chat talk quote project', href: '#book', mark: '15', type: 'consult' },
      { title: 'Work', sub: 'Case studies', keys: 'work portfolio case study examples clients sa art fair', href: '/pages/work', mark: 'W' }
    ];
    var esc = function (s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
    var matches = function (hay, q) {
      hay = hay.toLowerCase();
      if (hay.indexOf(q) !== -1) return true;
      return q.split(/\s+/).some(function (w) { return w.length > 2 && hay.indexOf(w) !== -1; });
    };
    var run = function () {
      var raw = input.value.trim();
      var q = raw.toLowerCase();
      search.classList.toggle('is-active', !!q);
      suggs.forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-fl-sugg').toLowerCase() === q ? 'true' : 'false'); });
      var shown = [];
      cards.forEach(function (c) {
        var hay = (c.getAttribute('data-keys') || '') + ' ' + c.textContent;
        var ok = !q || matches(hay, q);
        c.hidden = !ok;
        if (ok && q) shown.push(c);
      });
      if (filter) { filter.hidden = !q; if (filterTxt) filterTxt.textContent = shown.length + ' of ' + cards.length + ' for “' + raw + '”'; }
      if (noMatch) noMatch.hidden = !(q && shown.length === 0);
      if (!results) return;
      if (!q) { results.hidden = true; results.innerHTML = ''; return; }
      var items = shown.map(function (c) {
        return { title: c.getAttribute('data-title'), sub: c.getAttribute('data-sub'), href: c.getAttribute('data-href') || '#services', mark: c.getAttribute('data-mark'), hot: c.hasAttribute('data-dark') };
      }).concat(extras.filter(function (x) { return matches(x.title + ' ' + x.keys, q); }).map(function (x) {
        return { title: x.title, sub: x.sub, href: x.href, mark: x.mark, soft: true, type: x.type };
      })).slice(0, 5);
      var html = '<div class="fl-results__label">' + (items.length ? items.length + (items.length === 1 ? ' result' : ' results') + ' for “' + esc(raw) + '”' : 'No quick results for “' + esc(raw) + '”') + '</div>';
      items.forEach(function (it) {
        html += '<a href="' + esc(it.href) + '"' + (it.type ? ' data-fl-type="' + it.type + '"' : '') + '><span class="fl-results__tile' + (it.hot ? ' fl-results__tile--hot' : (it.soft ? ' fl-results__tile--soft' : '')) + '">' + esc(it.mark || '') + '</span><span class="fl-results__txt"><b>' + esc(it.title) + '</b><small>' + esc(it.sub || '') + '</small></span></a>';
      });
      html += '<div class="fl-results__empty">' + (items.length ? 'Press Search to look across the whole site.' : 'Press Search to look across the whole site, or <a href="#book" data-fl-type="consult">book a 15-min consult →</a>') + '</div>';
      results.innerHTML = html;
      results.hidden = false;
    };
    input.addEventListener('input', run);
    input.addEventListener('focus', function () { if (input.value.trim()) run(); });
    input.addEventListener('keydown', function (e) { if (e.key === 'Escape') { results.hidden = true; } });
    doc.addEventListener('click', function (e) { if (results && !search.contains(e.target)) results.hidden = true; });
    if (results) results.addEventListener('click', function (e) {
      var a = e.target.closest('a'); if (!a) return;
      var t = a.getAttribute('data-fl-type'); if (t) setCallType(t);
      results.hidden = true;
    });
    suggs.forEach(function (b) {
      b.addEventListener('click', function () {
        var v = b.getAttribute('data-fl-sugg');
        input.value = (input.value.trim().toLowerCase() === v.toLowerCase()) ? '' : v;
        run();
      });
    });
    $$('[data-fl-clear]').forEach(function (b) { b.addEventListener('click', function () { input.value = ''; run(); input.focus(); }); });
    var form = $('form', search);
    if (form) form.addEventListener('submit', function (e) {
      var q = input.value.trim().toLowerCase();
      var anyCard = cards.some(function (c) { return !c.hidden; });
      if (q && anyCard && cards.some(function (c) { return !c.hidden && matches((c.getAttribute('data-keys') || '') + ' ' + c.textContent, q); })) {
        e.preventDefault();
        results.hidden = true;
        var target = $('#services');
        if (target) target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      }
    });
  }

  /* ------------------------------------------------------------------
     Book a call (free audit / 15-min consult) — Shopify contact form
     ------------------------------------------------------------------ */
  var book = $('[data-fl-book]');
  function setCallType(t) {
    if (!book) return;
    var radio = $('input[name="fl-type"][value="' + t + '"]', book);
    if (radio) { radio.checked = true; radio.dispatchEvent(new Event('change', { bubbles: true })); }
  }
  doc.addEventListener('click', function (e) {
    var a = e.target.closest ? e.target.closest('[data-fl-type]') : null;
    if (a && !(results && results.contains && results.contains(a))) setCallType(a.getAttribute('data-fl-type'));
  });
  var results = search ? $('[data-fl-results]', search) : null;
  if (book) {
    var types = {
      audit: { label: 'Free audit', desc: 'A free 15-minute call: we go through your site, store or ads with you and tell you what to fix first, whether or not you work with us.', btn: 'Request audit call' },
      consult: { label: '15-min consult', desc: 'Talk through a new project and get a straight answer on scope, timing and cost.', btn: 'Request consult' }
    };
    var desc = $('[data-fl-desc]', book);
    var btnLabel = $('[data-fl-submit-label]', book);
    var fType = $('input[name="contact[Call type]"]', book);
    var fDay = $('input[name="contact[Day]"]', book);
    var fTime = $('input[name="contact[Time]"]', book);
    var daysWrap = $('[data-fl-days]', book);
    var times = $$('[data-fl-time]', book);
    var err = $('[data-fl-err]', book);
    var state = { type: 'audit', day: '', time: '' };
    var paint = function () {
      var t = types[state.type] || types.audit;
      if (desc) desc.textContent = t.desc;
      if (fType) fType.value = t.label;
      if (fDay) fDay.value = state.day;
      if (fTime) fTime.value = state.time;
      if (btnLabel) btnLabel.textContent = t.btn + (state.day && state.time ? ' · ' + state.day.split(' ')[0] + ' ' + state.time : '');
    };
    $$('input[name="fl-type"]', book).forEach(function (r) {
      r.addEventListener('change', function () { if (r.checked) { state.type = r.value; paint(); } });
    });
    if (daysWrap) {
      var names = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
      var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      var d = new Date(); var list = [];
      while (list.length < 5) {
        d.setDate(d.getDate() + 1);
        if (d.getDay() !== 0 && d.getDay() !== 6) list.push(new Date(d.getTime()));
      }
      daysWrap.innerHTML = '';
      list.forEach(function (dt, i) {
        var b = doc.createElement('button');
        b.type = 'button';
        var label = names[dt.getDay()] + ' ' + dt.getDate() + ' ' + months[dt.getMonth()];
        b.setAttribute('aria-pressed', i === 0 ? 'true' : 'false');
        b.setAttribute('aria-label', label);
        b.innerHTML = '<small>' + names[dt.getDay()] + '</small><b>' + dt.getDate() + '</b>';
        b.addEventListener('click', function () {
          $$('button', daysWrap).forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
          b.setAttribute('aria-pressed', 'true');
          state.day = label; paint();
        });
        daysWrap.appendChild(b);
        if (i === 0) state.day = label;
      });
      var pre = parseInt(new URLSearchParams(window.location.search).get('day'), 10);
      if (pre >= 0 && pre < list.length) { var pb = $$('button', daysWrap)[pre]; if (pb) pb.click(); }
    }
    times.forEach(function (b) {
      if (b.getAttribute('aria-pressed') === 'true') state.time = b.getAttribute('data-fl-time');
      b.addEventListener('click', function () {
        times.forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
        b.setAttribute('aria-pressed', 'true');
        state.time = b.getAttribute('data-fl-time'); paint();
      });
    });
    var params = new URLSearchParams(window.location.search);
    if (params.get('call') === 'consult') setCallType('consult');
    paint();
    var form = $('form', book);
    if (form) form.addEventListener('submit', function (e) {
      var name = $('input[name="contact[name]"]', form);
      var email = $('input[name="contact[email]"]', form);
      var ok = name && name.value.trim() && email && /.+@.+\..+/.test(email.value.trim());
      if (!ok) {
        e.preventDefault();
        if (err) err.hidden = false;
        (name && !name.value.trim() ? name : email).focus();
        return;
      }
      if (err) err.hidden = true;
      paint();
      if (fType) {
        var body = $('input[name="contact[body]"]', form);
        if (body) body.value = fType.value + ' request for ' + state.day + ' at ' + state.time + ' (sent from ' + window.location.pathname + ')';
      }
    });
    if ($('[data-fl-done]', book)) {
      Sound.success();
      setTimeout(function () { book.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' }); }, 200);
    }
  }

  /* ------------------------------------------------------------------
     Bhuka page: live demo, tabs, calculator
     ------------------------------------------------------------------ */
  var fmt = function (n) { return 'R' + String(Math.round(Math.abs(n))).replace(/\B(?=(\d{3})+(?!\d))/g, ','); };
  var demo = $('[data-bh-demo]');
  if (demo) {
    var PRICE = 360;
    var slots = $$('[data-bh-slot]', demo);
    var seatsOut = $('[data-bh-seats]', demo);
    var openBox = $('[data-bh-open]', demo);
    var fullBox = $('[data-bh-full]', demo);
    var pickView = $('[data-bh-pick]', demo);
    var okView = $('[data-bh-ok]', demo);
    var bubble = $('[data-bh-bubble]', demo);
    var toast = $('[data-bh-toast]', demo);
    var s = { slot: slots[0], seats: 2, booked: false };
    var slotInfo = function (b) { return { day: b.getAttribute('data-day'), time: b.getAttribute('data-time'), left: parseInt(b.getAttribute('data-left'), 10) || 0, base: parseInt(b.getAttribute('data-base'), 10) || 0, ev: b.getAttribute('data-ev') }; };
    var render = function () {
      var info = slotInfo(s.slot);
      var full = info.left === 0;
      var max = full ? 1 : Math.min(4, info.left);
      s.seats = Math.max(1, Math.min(s.seats, max));
      var total = s.seats * PRICE, dep = total / 2;
      var word = s.seats === 1 ? 'seat' : 'seats';
      slots.forEach(function (b) { b.setAttribute('aria-pressed', b === s.slot ? 'true' : 'false'); });
      if (seatsOut) seatsOut.textContent = s.seats;
      if (openBox) openBox.hidden = full;
      if (fullBox) fullBox.hidden = !full;
      var set = function (k, v) { $$('[data-bh="' + k + '"]', demo).forEach(function (el) { el.textContent = v; }); };
      set('seatline', s.seats + ' ' + word + ' × R360');
      set('total', fmt(total));
      set('deposit', fmt(dep));
      set('cta', full ? 'Join the waitlist' : 'Pay ' + fmt(dep) + ' deposit');
      var line = 'Collage & Mixed Media · ' + info.day + ' at ' + info.time;
      set('donetitle', full ? 'You’re on the waitlist.' : 'You’re booked.');
      set('doneline', full ? line + '. We’ll message you the moment a seat opens.' : line + ' · ' + s.seats + ' ' + word + '.');
      set('donepay', full ? 'No payment taken yet' : fmt(dep) + ' deposit paid via Shopify checkout');
      set('wa', full ? 'Hi! You’re on the waitlist for Collage & Mixed Media, ' + info.day + ' at ' + info.time + '. We’ll message you as soon as a seat opens.'
        : 'Hi! You’re booked for Collage & Mixed Media, ' + info.day + ' at ' + info.time + ', ' + s.seats + ' ' + word + '. Deposit of ' + fmt(dep) + ' received. See you there!');
      set('toast', full ? 'Waitlist +1' : 'New booking · ' + fmt(dep));
      if (pickView) pickView.hidden = s.booked;
      if (okView) okView.hidden = !s.booked;
      if (bubble) bubble.hidden = !s.booked;
      if (toast) toast.hidden = !s.booked;
      $$('[data-bh-ev]', demo).forEach(function (ev) {
        var id = ev.getAttribute('data-bh-ev');
        var b = slots.filter(function (x) { return x.getAttribute('data-ev') === id; })[0];
        if (!b) return;
        var bi = slotInfo(b);
        var just = s.booked && b === s.slot && bi.left > 0;
        var count = bi.base + (just ? s.seats : 0);
        var meta = $('em', ev);
        if (bi.left === 0) { if (meta) meta.textContent = (s.booked && b === s.slot) ? 'Full · +1 wait' : 'Full'; return; }
        ev.classList.toggle('bh-ev--fresh', just);
        if (meta) meta.textContent = count + '/12' + (just ? ' · new' : '');
      });
    };
    slots.forEach(function (b) { b.addEventListener('click', function () { s.slot = b; render(); }); });
    var minus = $('[data-bh-minus]', demo), plus = $('[data-bh-plus]', demo);
    if (minus) minus.addEventListener('click', function () { s.seats -= 1; render(); });
    if (plus) plus.addEventListener('click', function () { s.seats += 1; render(); });
    var bookBtn = $('[data-bh-book]', demo);
    if (bookBtn) bookBtn.addEventListener('click', function () { s.booked = true; render(); Sound.success(); });
    var again = $('[data-bh-again]', demo);
    if (again) again.addEventListener('click', function () { s.booked = false; s.slot = slots[0]; s.seats = 2; render(); });
    render();
  }

  var tablist = $('[data-bh-tabs]');
  if (tablist) {
    var tabs = $$('[role="tab"]', tablist);
    var select = function (tab) {
      tabs.forEach(function (t) {
        var on = t === tab;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        var p = doc.getElementById(t.getAttribute('aria-controls'));
        if (p) p.hidden = !on;
      });
    };
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { select(t); });
      t.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
          e.preventDefault();
          var n = tabs[(i + (e.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length];
          select(n); n.focus();
        }
      });
    });
  }

  var calc = $('[data-bh-calc]');
  if (calc) {
    var rb = $('#bh-bookings', calc), ra = $('#bh-avg', calc), rp = $('#bh-pct', calc);
    var out = function (k, v) { $$('[data-bhc="' + k + '"]').forEach(function (el) { el.textContent = v; }); };
    var update = function () {
      var b = +rb.value, a = +ra.value, p = +rp.value;
      out('bookings', b); out('avg', fmt(a)); out('pct', p + '%');
      var cutMonth = b * a * p / 100, cutYear = cutMonth * 12;
      var keep1 = cutYear - (4500 + 850 * 12), keepAfter = cutYear - 850 * 12;
      var net = cutMonth - 850, pay = net > 0 ? Math.ceil(4500 / net) : 0;
      out('year', fmt(cutYear));
      out('keep1', (keep1 < 0 ? '−' : '') + fmt(keep1));
      out('keepafter', (keepAfter < 0 ? '−' : '') + fmt(keepAfter));
      out('payback', net <= 0 ? 'At this volume, owning your data is the win' : (pay <= 1 ? 'Pays for itself in month one' : 'Pays for itself in about ' + pay + ' months'));
    };
    [rb, ra, rp].forEach(function (r) { if (r) r.addEventListener('input', update); });
    update();
  }

  /* ------------------------------------------------------------------
     Quick-book day links on inner pages ([data-flp-days])
     ------------------------------------------------------------------ */
  $$('[data-flp-days]').forEach(function (wrap) {
    var dn = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    var mn = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    var d = new Date(); var out = [];
    while (out.length < 3) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0 && d.getDay() !== 6) out.push(new Date(d.getTime())); }
    wrap.innerHTML = '';
    out.forEach(function (dt, i) {
      var a = doc.createElement('a');
      a.href = '/pages/book?day=' + i;
      a.setAttribute('data-fl-type', 'audit');
      a.setAttribute('aria-label', 'Book a free audit on ' + dn[dt.getDay()] + ' ' + dt.getDate() + ' ' + mn[dt.getMonth()]);
      a.innerHTML = '<small>' + dn[dt.getDay()] + '</small><b>' + dt.getDate() + '</b>';
      wrap.appendChild(a);
    });
  });
})();

/* ---------- Cart: tidy booking details (11 Oct 2026) ----------
   Session lines show date, time, place and payment in 3 short lines; everything else sits in "All booking details".
   Add-on lines (travel, gear, studio, rush) show one short line. Works again after the cart re-renders.
   Add-ons left without their shoot are removed automatically. */
(function () {
  if (!/\/cart\/?$/.test(location.pathname)) return;
  var css = document.createElement('style');
  css.textContent = '.fl-ct{margin:6px 0 0;display:grid;gap:3px;font-size:15px;line-height:1.45}.fl-ct b{font-weight:700}.fl-ct span{color:rgba(17,18,19,.72)}' +
    '.fl-ct details{margin-top:4px}.fl-ct summary{cursor:pointer;font-size:13px;font-weight:700;color:#C4141E;list-style:none}.fl-ct summary::-webkit-details-marker{display:none}' +
    '.fl-ct summary::after{content:" +"}.fl-ct details[open] summary::after{content:" −"}.fl-ct details dl{margin:6px 0 0}.fl-ct details .product-option{font-size:13px;margin:2px 0}';
  document.head.appendChild(css);
  var esc = function (t) { return String(t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
  function tidy(root) {
    (root || document).querySelectorAll('.cart-item__details dl:not([data-fl-ct])').forEach(function (dl) {
      var p = {};
      dl.querySelectorAll('.product-option').forEach(function (o) {
        var dt = o.querySelector('dt'), dd = o.querySelector('dd'); if (!dt || !dd) return;
        p[dt.textContent.replace(/:\s*$/, '').trim()] = dd.textContent.trim();
      });
      var lines = [];
      if (p['Date']) {
        lines.push('<b>' + esc([p['Shoot'], p['Session']].filter(Boolean).join(' · ')) + '</b>');
        lines.push('<span>' + esc(p['Date'] + (p['Start time'] ? ' · ' + p['Start time'] + (p['End time'] ? '–' + p['End time'] : '') : '')) + '</span>');
        if (p['Location']) lines.push('<span>' + esc(p['Location']) + '</span>');
        if (p['Paid now']) lines.push('<span>' + esc('Pay now: ' + p['Paid now'].replace(/\s*\(paid in full\)/, '') + (p['Balance on delivery'] ? ' · rest on delivery: ' + p['Balance on delivery'] : '')) + '</span>');
      } else if (p['For']) {
        lines.push('<span>' + esc(p['For']) + '</span>');
      } else return;
      var box = document.createElement('div'); box.className = 'fl-ct';
      box.innerHTML = lines.join('') + '<details><summary>All booking details</summary></details>';
      var row = dl.closest('.cart-item'), qi = row && row.querySelector('quantity-input, .quantity'); if (qi) qi.style.display = 'none';
      dl.setAttribute('data-fl-ct', '1');
      dl.parentNode.insertBefore(box, dl);
      box.querySelector('details').appendChild(dl);
    });
  }
  /* Removing a shoot also removes its travel, gear, studio and rush lines (they carry "For: <shoot> · <date> <time>"). */
  var sweeping = false;
  function sweep() {
    if (sweeping) return; sweeping = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
      var keys = c.items.filter(function (i) { return i.properties && i.properties['Date'] && i.properties['Start time']; })
        .map(function (i) { return i.properties['Date'] + ' ' + i.properties['Start time']; });
      var gone = c.items.filter(function (i) { var f = i.properties && i.properties['For']; return f && !keys.some(function (k) { return f.slice(-k.length) === k; }); });
      if (!gone.length) { sweeping = false; return; }
      var u = {}; gone.forEach(function (i) { u[i.key] = 0; });
      return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ updates: u }) })
        .then(function () { location.reload(); });
    }).catch(function () { sweeping = false; });
  }
  tidy(); sweep();
  var host = document.querySelector('cart-items, #main-cart-items') || document.body, wait = 0;
  new MutationObserver(function () { tidy(); clearTimeout(wait); wait = setTimeout(sweep, 400); }).observe(host, { childList: true, subtree: true });
})();

/* ---------- Cart: EFT for now + pay-before discount note (11 Oct 2026) ----------
   Card checkout is switched off until Yoco turns on online payments. Remove this block when cards are back. */
(function () {
  if (!/\/cart\/?$/.test(location.pathname)) return;
  var css = document.createElement('style');
  css.textContent = '.fl-paynote{margin:0 0 14px;padding:12px 14px;border-radius:14px;background:#E6F4EA;color:#1F5E33;font-size:14px;line-height:1.5;text-align:left}' +
    '.fl-paynote b{font-weight:800}.fl-paynote p{margin:0}.fl-paynote p+p{margin-top:6px}';
  document.head.appendChild(css);
  function add() {
    if (document.querySelector('.fl-paynote')) return;
    var btn = document.querySelector('#checkout, [name="checkout"]'); if (!btn) return;
    var at = btn.closest('.cart__ctas') || btn;
    var n = document.createElement('div'); n.className = 'fl-paynote';
    n.innerHTML = '<p><b>Pay by EFT for now.</b> Instant card payments are coming soon. Choose PayShap in your banking app and your payment lands straight away.</p>' +
      '<p><b>Pay before your shoot and save:</b> 30% off when you pay in full, 15% off when you pay half. Paying after the shoot is the regular price.</p>';
    at.parentNode.insertBefore(n, at);
  }
  add();
  new MutationObserver(add).observe(document.body, { childList: true, subtree: true });
})();
